import { Checkbox, Grid, Typography } from "@mui/material";

import { colors } from "../../css components/Style";
import {
  ComponentHeader,
  Paper,
  TextField,
  TextFieldWithCopy,
} from "../../../components";
import { Fragment } from "react";

export default function FormDisplay({
  configName,
  formikProps,
  field,
  editState,
  subscriptionID,
}) {
  return (
    <Fragment>
      {subscriptionID && <GetPaper />}

      {!configName && (
        <Paper>
          <Grid size={4}>
            <TextField
              disabled={!editState}
              size="small"
              name="leadSubscriptionName"
              formikProps={formikProps}
              label="Name"
            />
          </Grid>

          <Grid size={12}>
            <Typography variant="h5" style={{ fontWeight: 600 }}>
              {!subscriptionID
                ? "Understand your users better — what audience parameters are you looking for?"
                : "Selected User Parameters"}
            </Typography>
          </Grid>

          {field.map(
            (fi) =>
              fi.is_active && (
                <Grid size={4} style={{ display: "flex" }}>
                  <Checkbox
                    disabled={!editState}
                    inputProps={{ "aria-label": "controlled" }}
                    checked={formikProps.values.selectedFields.includes(
                      fi.field_id
                    )}
                    onChange={(e) => {
                      if (e.target.checked) {
                        formikProps.setValues((prev) => ({
                          ...prev,
                          selectedFields: [...prev.selectedFields, fi.field_id],
                        }));
                      } else {
                        let fields = formikProps.values.selectedFields ?? [];
                        fields.splice(fields.indexOf(fi.field_id), 1);
                        formikProps.setValues((prev) => ({
                          ...prev,
                          selectedFields: fields,
                        }));
                      }
                    }}
                    sx={{
                      padding: "0px",
                      color: colors.purple,
                      "&.Mui-checked": {
                        color: colors.purple,
                      },
                    }}
                  />
                  <Typography
                    style={{
                      marginLeft: "15px",
                      position: "relative",
                      top: "2px",
                    }}
                  >
                    {fi.label}
                  </Typography>
                </Grid>
              )
          )}
        </Paper>
      )}

      {formikProps.values.id && configName && (
        <Paper>
          <Grid size={12}>
            <ComponentHeader title={"API Details"} />
          </Grid>

          <Grid size={6}>
            <TextFieldWithCopy
              disabled
              size="small"
              name="apiDetails.configName"
              formikProps={formikProps}
              label="Name"
            />
          </Grid>

          <Grid size={6}>
            <TextFieldWithCopy
              disabled
              size="small"
              name="apiDetails.method"
              formikProps={formikProps}
              label="Method"
              multiline
            />
          </Grid>

          <Grid size={6}>
            <TextFieldWithCopy
              disabled
              size="small"
              name="apiDetails.apiKey"
              formikProps={formikProps}
              label="API Key"
              multiline
            />
          </Grid>

          <Grid size={6}>
            <TextFieldWithCopy
              disabled
              size="small"
              name="apiDetails.apiUrl"
              formikProps={formikProps}
              label="API Url"
              multiline
            />
          </Grid>

          <Grid size={6}>
            <TextFieldWithCopy
              disabled
              size="small"
              name="apiDetails.apiCurl"
              formikProps={formikProps}
              label="API Curl"
              multiline
            />
          </Grid>
        </Paper>
      )}
    </Fragment>
  );

  function GetPaper() {
    return !formikProps.values.price ? (
      <Paper>
        <Grid size={12}>
          <Typography variant="h4" color={colors.info}>
            Your request is pending for approval !!
          </Typography>
        </Grid>
      </Paper>
    ) : (
      <Paper>
        <Grid
          size={12}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignSelf: "center",
          }}
        >
          <Typography variant="h4" color={colors.info}>
            {!formikProps.values.apiDetails && (
              <Fragment>
                Your request has been approved,Please confirm the Pricing and
                generate the api by clicking generate button
                <br />
              </Fragment>
            )}
            Status : {formikProps.values.status ? "Active" : "Inactive"}
          </Typography>

          {formikProps.values.price && subscriptionID && (
            <div
              style={{
                cursor: "pointer",
                height: "40px",
                border: `1px solid ${colors.purple}`,
                color: colors.purple,
                width: "80px",
                borderRadius: "5px",
                margin: "auto 10px",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {formikProps.values.price} INR
            </div>
          )}
        </Grid>
      </Paper>
    );
  }
}
